import React from 'react'
import PropTypes from 'prop-types'
// import R from 'ramda'

import BaseSelectField from './baseSelect'
import {
  AC_TYPES
} from "../../server/constants";

export const AC_TYPE_OPTIONS = [
  { text: 'full', value: AC_TYPES.FULL },
  { text: 'term-days', value: AC_TYPES.TERM_DAYS },
  { text: 'term-date', value: AC_TYPES.TERM_DATE }
]

const popupTxt = `What kind of license will the end-user get?
Type 'full' will grant a full license that never expires.
Type 'term-date' will grant a time-limited license with fixed expiration date.
Type 'term-days' will grant a time-limited license with the exp. date set to # of days after activation.`

const AcTypeField = ({
  name,
  width,
  onChange,
  value,
  options
}) => (
  <BaseSelectField
    name={name}
    placeholder='Select'
    width={width}
    onChange={onChange}
    value={value}
    options={ options || AC_TYPE_OPTIONS }
    labelTxt='Type'
    popupTxt={popupTxt}
  />
)

AcTypeField.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  options: PropTypes.array
}
export default AcTypeField



// WEBPACK FOOTER //
// ./webAdmin/forms/acType.js